<template>
  <div
    v-if="items.length"
    class="border-t border-gray-200 py-5"
    data-test-id="event-included"
  >
    <div class="flex items-center">
      <IconIncluded
        class="mt-0.5 size-5 shrink-0 text-teal-600"
        aria-hidden="true"
      />
      <div class="ml-4 min-w-0">
        <h2 class="text-base font-semibold leading-6 text-stone-800">
          {{ title }}
        </h2>
      </div>
    </div>

    <ul
      class="mt-4 list-disc space-y-2 pl-5 text-sm text-stone-600"
      data-test-id="event-included-list"
    >
      <li
        v-for="(item, index) in items"
        :key="`${index}-${item}`"
        :data-test-id="`event-included-item-${index}`"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { PencilRuler as IconIncluded } from 'lucide-vue-next'
import type { EventDescription } from '~/composables/types/event'
import { useTitleByCategory } from '~/composables/product/useGetTitleByCategory'

const {
  included,
  eventData = {} as EventDescription,
  isGiftcard = false,
} = defineProps<{
  included?: string[] | null
  eventData?: EventDescription
  isGiftcard?: boolean
}>()

const { getTitleByCategory } = useTitleByCategory()

const items = computed(() => included?.filter(Boolean) ?? [])
const title = computed(() =>
  getTitleByCategory('whatIsIncluded', eventData, isGiftcard)
)
</script>
